import * as i0 from "@angular/core";
var WindowsService = /** @class */ (function () {
    function WindowsService() {
    }
    WindowsService.prototype.alert = function (message) {
        window.alert(message);
    };
    WindowsService.prototype.reload = function () {
        window.location.reload();
    };
    WindowsService.prototype.setInterval = function (callback, duration) {
        return window.setInterval(callback, duration);
    };
    WindowsService.prototype.clearInterval = function (timer) {
        if (timer) {
            window.clearInterval(timer);
        }
    };
    WindowsService.ngInjectableDef = i0.defineInjectable({ factory: function WindowsService_Factory() { return new WindowsService(); }, token: WindowsService, providedIn: "root" });
    return WindowsService;
}());
export { WindowsService };
